import { Injectable } from '@angular/core';
import { IO365ShellShim } from '@suiteux/suiteux-shell';

import { SearchConfigService } from '../../search-results/services/search-config.service';
import { FileType } from '../../shared/models/file-item.model';
import { LocService } from '../../shared/shared-context/loc.service';

export interface LearningModel {
    displayText: string;
    onClick: () => void;
}

@Injectable({
    providedIn: 'root'
})
export class Learnings {

    private excelLearnings: Array<LearningModel>;
    private homePageLearnings: Array<LearningModel>;
    private powerPointLearnings: Array<LearningModel>;
    private wordPageLearnings: Array<LearningModel>;

    constructor(
        private readonly locService: LocService,
        private readonly searchConfigService: SearchConfigService
    ) {
    }

    public initializeSettingList(shellShim: IO365ShellShim) {
        this.homePageLearnings = [
            {
                // Try searching "resume templates"
                displayText: this.locService.format(this.searchConfigService.config.resources.SearchSuggestionLearningButtonText1, this.searchConfigService.config.resources.SearchSuggestionLearningContentText3),
                onClick: () => shellShim.Search.SetSearchText(this.searchConfigService.config.resources.SearchSuggestionLearningContentText3)
            }
        ];

        this.wordPageLearnings = [
            {
                // Try searching "resume templates"
                displayText: this.locService.format(this.searchConfigService.config.resources.SearchSuggestionLearningButtonText1, this.searchConfigService.config.resources.SearchSuggestionLearningContentText3),
                onClick: () => shellShim.Search.SetSearchText(this.searchConfigService.config.resources.SearchSuggestionLearningContentText3)
            }
        ];

        this.excelLearnings = [
            {
                // Try searching "budget templates"
                displayText: this.locService.format(this.searchConfigService.config.resources.SearchSuggestionLearningButtonText1, this.searchConfigService.config.resources.SearchSuggestionLearningContentText1),
                onClick: () => shellShim.Search.SetSearchText(this.searchConfigService.config.resources.SearchSuggestionLearningContentText1)
            }
        ];

        this.powerPointLearnings = [
            {
                // Try searching "brochure templates"
                displayText: this.locService.format(this.searchConfigService.config.resources.SearchSuggestionLearningButtonText1, this.searchConfigService.config.resources.SearchSuggestionLearningContentText2),
                onClick: () => shellShim.Search.SetSearchText(this.searchConfigService.config.resources.SearchSuggestionLearningContentText2)
            }
        ];
    }

    public getLearningList(app: FileType): Array<LearningModel> {
        switch (app) {
            case FileType.Word:
                return this.wordPageLearnings;
            case FileType.Excel:
                return this.excelLearnings;
            case FileType.PowerPoint:
                return this.powerPointLearnings;
            default:
                return this.homePageLearnings;
        }
    }
}
